import { render, staticRenderFns } from "./Archive.vue?vue&type=template&id=f6d1533c&scoped=true&v-if=this.user.loggedIn"
import script from "./Archive.vue?vue&type=script&lang=js"
export * from "./Archive.vue?vue&type=script&lang=js"
import style0 from "./Archive.vue?vue&type=style&index=0&id=f6d1533c&prod&scoped=true&lang=css"
import style1 from "./Archive.vue?vue&type=style&index=1&id=f6d1533c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6d1533c",
  null
  
)

export default component.exports